import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { LANG_JP, LANG_KO, langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import ApiController from "../../controller/ApiController";
import {
  authState,
  authStoreType,
  authType,
  masterStoreState,
} from "../../recoil/auth";
import { contentName } from "../../utils/util";

const GuideModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  store_id: number;
  roomTip: number;
}) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const master = useRecoilValue<authStoreType | null>(masterStoreState);
  const auth = useRecoilValue<authType>(authState);
  const [pickupZone, setPickupZone] = useState<string>("");
  const [pickupZoneEn, setPickupZoneEn] = useState<string>("");
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  // API 호출
  const setStorDeliveryData = async (store_id: number) => {
    if (master) {
      let res = await ApiController.store.getStoreOrderData(
        store_id,
        master.store_id,
        auth.user_token_id,
        0
      );

      if (res && res.data) {
        setPickupZone(res.data.pickup_name);
        setPickupZoneEn(res.data.pickup_name_en);
      }
    }
  };

  useEffect(() => {
    if (oProps.isVisible) setStorDeliveryData(oProps.store_id);
  }, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: "guideModal",
        overlay: "guideModalOverlay",
      }}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            {/* <h1> {langText.guideModal_title[lang]}</h1> */}
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/img/logo.png`}
              alt="logo"
            />
          </div>
          <div className="modal_content">
            <div>
              <div className="row">
                <div className="circle">
                  <h4>1</h4>
                </div>
                {/* <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_circle_green.svg`}
                  alt="대분류체크"
                /> */}
                <h2>{langText.guideModal_title_one[lang]}</h2>
              </div>
              {/* <h3>{langText.guideModal_content_one[lang]}</h3> */}
              <br />
              <div className="row">
                {/* <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_circle_green.svg`}
                  alt="대분류체크"
                /> */}
                <div className="circle">
                  <h4>2</h4>
                </div>
                <h2>{langText.guideModal_title_two[lang]}</h2>
              </div>
              {/* <h3>{langText.guideModal_content_two[lang]}</h3> */}
              <br />
              <div className="row">
                {/* <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_circle_green.svg`}
                  alt="대분류체크"
                /> */}
                <div className="circle">
                  <h4>3</h4>
                </div>
                <h2>{langText.guideModal_title_three[lang]}</h2>
              </div>

              <h4>{langText.guideModal_title_three_span[lang]}</h4>
              {/* <br /> */}
              {/* {oProps.roomTip > 0 && (
                <>
                  <div className="row">
                    <div className="circle">
                      <h4>4</h4>
                    </div>
                    <h2>{langText.guideModal_room_tip[lang]}</h2>
                  </div>
                  <h4>- {langText.guideModal_room_tip_notice[lang]}</h4>
                </>
              )} */}

              {/* <h3>{langText.guideModal_content_three[lang]}</h3> */}
              <h3 className="footer">{langText.guideModal_footer[lang]}</h3>
            </div>
            <div className="pickupBadge">
              <h3>
                {`${langText.arrivalModal_pickup[lang]}: ${
                  lang === 0 ? pickupZone : pickupZoneEn
                }`}
              </h3>
            </div>
            <button className="submitButton" onClick={onCloseModal}>
              {langText.guideModal_button_confirm[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default GuideModal;

const Style = styled.div`
  .modal {
    padding: 8% 8%;
  }

  .modal_header {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 7%;
    img {
      width: 100px;
      object-fit: contain;
    }
    h1 {
      font-size: 40px;
      line-height: 60px;
      font-weight: 600;
      color: #4dd2ae;
    }
    h1.content {
      color: #ffffff;
    }
  }
  .modal_content {
    width: 100%;
    white-space: pre-line;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .row {
      padding: 12px 0;
      display: flex;
      align-items: center;
      gap: 16px;
    }

    h2 {
      font-size: 28px;
      line-height: 32px;
      font-weight: 600;
      color: #ffffff;
      span {
        color: #ffffff;
        font-weight: 600;
        background: #40977f;
      }
    }

    h4 {
      padding-left: 5%;
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      line-height: 32px;
    }
    h3 {
      padding: 6px 0 20px 0;
      font-size: 18px;
      line-height: 28px;
      font-weight: 400;
      color: #ffffff;
    }
    h3.footer {
      padding-top: 12%;
    }
  }

  .pickupBadge {
    /* position: absolute;
    top: -30%; */
    left: 0;
    right: 0;
    display: inline-flex;
    justify-content: center;

    h3 {
      padding: 6px 20px;
      line-height: 22px;
      font-weight: 500;
      color: #ffffff;
      background: #ff4a4a;
      border-radius: 50px;
    }
  }

  .submitButton {
    position: relative;
    /* margin-top: 16px; */
    margin-top: 10px;
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 100px;
    background: #4dd2ae;
    h4 {
      color: #343434;
      font-weight: 600;
    }
  }
`;
